var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-popup',{style:({ height: '100%', overflow: 'hidden' }),attrs:{"close-on-click-overlay":false},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"popup-container"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }